var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dynamiques / Icones / Illustratif / Son") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dynamiques-/-Icones-/-Illustratif-/-Son",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#292927",
    strokeWidth: 1.2,
    points: "19.066 21.328 7 21.328 7 38.077 19.066 38.077 33 49 33 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.234,12.4276 C49.738,16.9316 52.528,23.1416 52.528,29.9986 C52.528,36.8556 49.738,43.0666 45.234,47.5706",
    id: "Stroke-4",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5279,20.1337 C40.0519,22.6577 41.6189,26.1497 41.6189,29.9987 C41.6189,32.2277 41.0959,34.3387 40.1539,36.2087 C39.4839,37.5657 38.5879,38.8037 37.5279,39.8627",
    id: "Stroke-6",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3776,16.284 C42.9586,17.866 44.2756,19.721 45.2336,21.77 C46.4186,24.263 47.0736,27.061 47.0736,29.999 C47.0736,32.944 46.4186,35.733 45.2336,38.227 C44.2756,40.276 42.9586,42.131 41.3776,43.713",
    id: "Stroke-8",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5279,39.8631 C38.5879,38.8031 39.4839,37.5651 40.1539,36.2091 C41.0959,34.3391 41.6189,32.2271 41.6189,29.9991 C41.6189,26.1491 40.0519,22.6581 37.5279,20.1341",
    id: "Stroke-10",
    stroke: "#292927",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.066,
    y1: 21.328,
    x2: 19.066,
    y2: 38.077,
    id: "Stroke-12",
    stroke: "#292927",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeaker);
export default __webpack_public_path__ + "static/media/icon-speaker.968f47f1b763a69105d4551e93554ac4.svg";
export { ForwardRef as ReactComponent };